module.exports = __webpack_public_path__ + "h5/img/tehui.73c7d0c2.jpg";